import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { statusIconMap } from '../comparables.constants';

@Component({
  selector: 'smartflip-status-legend',
  imports: [IonicModule],
  templateUrl: './statusLegend.component.html',
  styleUrl: './statusLegend.component.scss',
})
export class StatusLegendComponent {
  public showPopup = false;
  public statuses = Object.entries(statusIconMap).map(([key, value]) => ({
    key,
    value,
  }));
}
